import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {deleteCategoryWeb} from '../../../redux/actions/categoriesActions';

class CategoryLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDelete: false,
    }
  }
  handleDelete = () => {
    this.setState({
      confirmDelete: !this.state.confirmDelete,
    })
  }
  confirmDelete = () => {
    const categoryId = this.props.category.categoryId;
    this.props.deleteCategoryWeb(categoryId)
  }
  render() {
    const { index, category } = this.props;
    const {confirmDelete} = this.state;
  return (
    <tr>
        <td style={{width: 50}}>{index} </td>
        <td style={{width: 50}}><div className="featuredImage" style={{backgroundImage: `url(${category.featuredImage ? category.featuredImage : '/images/no-image.jpg'})`}} /></td>
        <td>{category.name.vi}</td>
        <td>
          {category.parentId.map((parent, index1) => (
            <div className={`chip ${index1 === 0 ? 'bgSuccess textWhite' : ''}`} key={index1} style={{fontSize: 12}}>
              <span>{parent.label}</span>
            </div>
          ))
          }</td>
        <td>{category.slug}</td>
        <td className="alignCenter" style={{width: 80}}>{category.sort}</td>
        <td>
          {confirmDelete ?
          <div>
            <button className="button button-danger mr-5" onClick={this.confirmDelete}>OK</button>
            <button className="button" onClick={this.handleDelete}>Huỷ</button>
          </div>
          :
          <div>
            <Link to={`/bai-viet/danh-muc/chinh-sua/${category.categoryId}`} category={category}>
              <button className="button">Sửa</button>
            </Link>
            <button className="button ml-5" onClick={this.handleDelete}>Xoá</button>
          </div>
          }
        </td>
    </tr>
  )
  }
}

CategoryLists.propTypes = {
    deleteCategoryWeb: PropTypes.func.isRequired,
}

export default connect(null, { deleteCategoryWeb })(CategoryLists);
